export default () => ({
	default: {
		width: 1.50,
		pole: 0.07,
		adapter: 0.025,
		slip: 0.0225,
		bottom: 0.055,
	},
});